module.exports = __webpack_public_path__ + "static/media/Flik6_Index.74b0a724.pdf";